import React, { useEffect, useMemo, useRef } from 'react';
// TODO: APP-3570 Remove when rets2 decodes
import { decode } from 'html-entities';

import { Formik, Form, Field } from 'formik';
import styled from 'styled-components';
import { getPhoneInputMask, correctShowingTypeLabel } from 'utils';
import { Tag, theme, ContactMethodsSelector } from 'components';
import { UserRoles } from '@bb/users';

import { OverrideOptionType } from '@app/listing/appointments/appointment_booking/AppointmentOverride';
import { InviteBuyer } from '../../../../Router/components';
import styles from './appointment_book.module.scss';

interface SelectedUserProps {
  selectedUser: any;
  appointment: any;
  bookFor: any;
  sameOrg: any;
  customContact: any;
  showNote: any;
  setShowNote: any;
  appointmentTypes: any;
  listing: any;
  customContactSaved: any;
  updateState: any;
  selectNotifyMethod: any;
  showingOverrideType: OverrideOptionType;
  inviteBuyers: any[];
  setInviteBuyers: any;
  auth: any;
  $rootScope: any;
}

const Step1SelectedUser: React.FC<SelectedUserProps> = ({
  selectedUser,
  appointment,
  customContactSaved,
  bookFor,
  sameOrg,
  customContact,
  showNote,
  setShowNote,
  appointmentTypes,
  listing,
  updateState,
  selectNotifyMethod,
  showingOverrideType,
  inviteBuyers,
  setInviteBuyers,
  auth,
  $rootScope,
}) => {
  const phoneRef = useRef<HTMLInputElement>();

  const validate = (values: any) => {
    const error = {};
    updateState((draft: any) => {
      draft.appointment.coop.phone = values.phone;
      draft.appointment.coop.email = values.email || appointment.coop.email;
      draft.appointment.type = values.showingType;
      draft.appointment.note = values.notes;
    });
    return error;
  };

  const initialValues = {
    phone: appointment?.coop?.phone || '',
    notifyEmail: appointment?.notify?.email || '',
    email: appointment?.coop?.email || '',
    notifyOffice: appointment?.notify?.office || '',
    showingType:
      showingOverrideType || appointment?.type || appointmentTypes[0],
  };

  const selectedUserObj = useMemo(() => {
    const { emails, email, org, notifications } = selectedUser;
    return {
      email: emails[0] || email || appointment?.coop?.email || '',
      phone: appointment.coop?.phone || '',
      officePhone: org.phone,
      bookShowingDefault: notifications?.officeMessages.bookShowingDefault,
    };
  }, [selectedUser, appointment]);

  useEffect(() => {
    validate(initialValues);
  }, []);

  useEffect(() => {
    if (phoneRef.current) {
      getPhoneInputMask().mask(phoneRef.current);
    }
  }, [phoneRef.current]);

  return (
    <Formik
      initialValues={initialValues}
      validate={values => validate(values)}
      onSubmit={values => console.log(values)}
      enableReinitialize
    >
      {({ isSubmitting }) => (
        <Form>
          <div>
            <div className="form-group">
              <label>Name: </label> {decode(selectedUser.firstName)}{' '}
              {decode(selectedUser.lastName)}
              <h5>{decode(selectedUser.org.name)}</h5>
              {decode(selectedUser.org.address)}
            </div>

            <span className={styles.invisibleOnMobile}>
              {selectedUser && (
                <div className="form-group">
                  <label>Mobile:</label>
                  <Field
                    name="phone"
                    type="text"
                    className="form-control"
                    placeholder="Phone"
                    data-cy="appointment-phone"
                    innerRef={phoneRef}
                  />
                </div>
              )}

              <div className="form-group">
                {selectedUser && bookFor !== 'nonAgent' && (
                  <div>
                    <label>Send Instruction By </label>
                    <ContactMethodsSelector
                      selectedUser={selectedUserObj}
                      selectNotifyMethod={selectNotifyMethod}
                      hasSmsFeature={appointment.coop?.orgFeatures?.includes(
                        'SHOWING_AGENT_SMS',
                      )}
                    />
                  </div>
                )}

                {!customContact &&
                  !customContactSaved &&
                  bookFor !== 'nonAgent' && (
                    <div className="form-group">
                      <label>Showing Type</label>
                      <Field
                        name="showingType"
                        component="select"
                        disabled={!!showingOverrideType}
                        className="form-control"
                        data-cy="showing-type"
                      >
                        {appointmentTypes &&
                          appointmentTypes.map((at: any) => (
                            <option key={at} value={at}>
                              {correctShowingTypeLabel(at)}
                            </option>
                          ))}
                      </Field>
                    </div>
                  )}
                {selectedUser && selectedUser.uid && (
                  <a
                    style={{ color: 'white' }}
                    href={`/rets/${
                      listing.org.id
                    }/appointment_redirect?listingId=${listing.id}&uid=${
                      selectedUser.uid
                    }${
                      selectedUser.mlsType ? `&mls=${selectedUser.mlsType}` : ''
                    }`}
                    className="pull-right"
                    target="_blank"
                    rel="noreferrer"
                  >
                    View MLS Link
                  </a>
                )}

                {showNote && !customContact && (
                  <div className="form-group">
                    <label>Notes</label>
                    <Field
                      name="notes"
                      component="textarea"
                      className="form-control"
                      rows={6}
                      data-cy="input-note"
                    />
                  </div>
                )}
                {!showNote && !customContact && (
                  <button
                    onClick={() => setShowNote(true)}
                    className="btn btn-default"
                    data-cy="add-note"
                  >
                    Add Note
                  </button>
                )}
              </div>
            </span>
            {auth.role > UserRoles.Agent && (
              <StyledContainer>
                <label>
                  Invite Buyers <StyleTag color="blue1">New</StyleTag>
                </label>
                <InviteBuyer
                  agent={selectedUser}
                  value={inviteBuyers}
                  onValueChange={setInviteBuyers}
                  listing={listing}
                  $rootScope={$rootScope}
                />
              </StyledContainer>
            )}
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default Step1SelectedUser;

const StyledContainer = styled.div`
  margin-top: 15px;
`;

const StyleTag = styled(Tag)`
  border: 1px solid ${theme.blue6};
  color: ${theme.blue6};
  border-radius: 2px;
  margin-left: 5px;
`;
